import React      from 'react';
import { Helmet } from 'react-helmet-async';
import Hidden     from '@mui/material/Hidden';
import Grid       from '@mui/material/Grid';
import Box        from '@mui/material/Box';
import Graphic    from '../../resources/images/PXL_logo_nouhin_white.png';
import { styled } from '@mui/material/styles';

// Convert from makeStyles to styled components for MUI v5
const StyledGrid = styled(Grid)(({ theme }) => ({
	height: '100vh',
	width: '100%',
	[theme.breakpoints.down('md')]: {
		paddingRight: '12px',
		paddingLeft: '12px',
		margin: '0px'
	}
}));

const StyledBox = styled(Box)(({ theme }) => ({
	height: '100vh',
	backgroundColor: theme.palette.primary?.main || '#ff9100', /* For browsers that do not support gradients */
	backgroundImage: theme.palette.primary?.gradient || 'linear-gradient(to right, #e40043 ,#f58e28)',
}));

const StyledGridItem = styled(Grid)({
	height: '100vh',
});

const LayoutLess = ({ title, children }) => {
	return (
        <StyledGrid container justifyContent='center' alignItems='center'>
            <Helmet>
				<title>{title}</title>
			</Helmet>
            <Hidden mdDown>
				<StyledGridItem item md={7}>
					<StyledBox>
						<Grid container
						      direction='row'
						      justifyContent='center'
						      alignItems='center' sx={{ height: '100vh' }}>
							<Grid item xs={6}>
								<img src={Graphic} width='100%' alt='PXL'/>
							</Grid>
						</Grid>
					</StyledBox>
				</StyledGridItem>
			</Hidden>
            <Grid item xs={12} md={5}>
				{children}
			</Grid>
        </StyledGrid>
    );
};

export default LayoutLess;
